import React from "react";

import { ceil } from "~/tools/ceil";
import { max } from "~/tools/max";

import { ContextLessDocLink } from "../docLink/DocLink";
import { notification } from "../notification/Notification";

const BUCKET_WIDTH_IN_PIXELS = 15;

export const getBucketCount = (width: number) => max(1, ceil(width / BUCKET_WIDTH_IN_PIXELS, 0));

export const warningMessageHalfYearLimit = (docLinkUrlPrefix: string): void =>
	void notification.warning({
		duration: 7,
		message: "You can not use a time interval larger than 6 months.",
		description: (
			<ContextLessDocLink capture="noop" docLinkUrlPrefix={docLinkUrlPrefix} slug="ui-time-interval-limit">
				Learn more
			</ContextLessDocLink>
		),
	});
